<template lang="pug">
d2-container
  el-form(
    :inline="true",
    :model="dataForm",
    size="mini",
    label-position="left",
    label-width="75px",
    label-suffix=":"
  )
    el-row(:span="24", type="flex", :gutter="40")
      el-col(:md="8", :sm="12")
        el-radio-group(
          v-model="timeRange",
          @change="timeChange",
          fill="#409EFF",
          style="display: flex; flex-warp: nowarp"
        )
          el-radio-button(:label="0") 今天
          el-radio-button(:label="1") 本周
          el-radio-button(:label="2") 上周
          el-radio-button(:label="3") 本月
          el-radio-button(:label="4") 上月
      el-col(:md="8", :sm="12")
        el-date-picker(
          v-model="dateTime",
          @change="dayChange",
          type="daterange",
          value-format="yyyy-MM-dd",
          range-separator="至",
          start-placeholder="开始日期",
          end-placeholder="结束日期"
        )
      //- el-col(:md='8' :sm="12" )
      //-   el-radio-group(v-model="dataForm.dateType" @change="dateChange" fill="#409EFF" style='display:flex;flex-warp:nowarp')
      //-     el-radio-button(:label="1") 按月
      //-     el-radio-button(:label="2") 按季
      //-     el-radio-button(:label="3") 按年
      el-col(:span="8")
        el-form-item(label="主办方", size="medium")
          el-select.inputWidth(
            v-model="dataForm.orgId",
            placeholder="请选择主办方",
            filterable,
            clearable
          )
            el-option(
              v-for="(e, i) in orgList",
              :key="i",
              :label="e.name",
              :value="e.orgId"
            )
    //- el-row( style='margin:20px 0 0 0' :gutter="40")
    el-row(style="padding-bottom: 15px")
      el-col(:span="24")
        el-button(
          type="primary",
          v-show="isAuth('fs:statical:frans')",
          @click="exportExcel()",
          style="margin-left: 0"
        ) 导出报表
        el-button(
          type="primary",
          icon="el-icon-search",
          @click="getDataList",
          style="float: right"
        ) 查询
    //- el-row(:span='24' type='flex' justify="start")
    //-   h3(style="margin:20px 100px 0 0;color:red") 总计：{{ctCount}}场比赛
    //-   h3(style="margin:20px 100px 0 0;color:red") {{trCount}}场培训
    //-   h3(style="margin:20px 100px 0 0;color:red") 总收入 ¥ {{totalAmount}}元
    //-   h3(style="margin:20px 100px 0 0;color:red") 总加盟费 ¥ {{totalFranchise}}元
    //-   h3(style="margin:20px 100px 0 0;color:red") 总手续费 ¥ {{serviceFee}}元
  el-table(
    :data="infoDataList",
    border,
    v-loading="dataListLoading",
    style="width: 100%; margin-bottom: 40px"
  )
    el-table-column(
      prop="ctCount",
      header-align="center",
      align="center",
      label="已结束比赛场次(数)"
    )
    el-table-column(
      prop="totalCtNotEndCount",
      header-align="center",
      align="center",
      label="未结束比赛场次(数)"
    )
    el-table-column(
      prop="endTotalAmountCt",
      header-align="center",
      align="center",
      label="已结束比赛总额(元)"
    )
    el-table-column(
      prop="trCount",
      header-align="center",
      align="center",
      label="已结束培训场次(数)"
    )
    el-table-column(
      prop="totalTrNotEndCount",
      header-align="center",
      align="center",
      label="未结束培训场次(数)"
    )
    el-table-column(
      prop="endTotalAmountTr",
      header-align="center",
      align="center",
      label="已结束培训总额(元)"
    )
    el-table-column(
      prop="totalPlaceAmt",
      header-align="center",
      align="center",
      label="约场地总额(元)"
    )
    el-table-column(
      prop="totalAmount",
      header-align="center",
      align="center",
      label="不含退款收入(元)"
    )
    el-table-column(
      prop="totalRefundBalanced",
      header-align="center",
      align="center",
      label="总退款余额(元)"
    )
    el-table-column(
      prop="totalAmountFranchiseePay",
      header-align="center",
      align="center",
      label="加盟商打款总额(元)"
    )
    el-table-column(
      prop="totalFranchise",
      header-align="center",
      align="center",
      label="总加盟费(元)"
    )
    el-table-column(
      prop="serviceFee",
      header-align="center",
      align="center",
      label="总提现手续费(元)"
    )
  el-table(
    :data="dataList",
    border,
    v-loading="dataListLoading",
    style="width: 100%"
  )
    el-table-column(
      type="index",
      header-align="center",
      align="center",
      label="序号"
    )
    el-table-column(
      prop="orgName",
      header-align="center",
      align="center",
      label="加盟商名称"
    )
    el-table-column(
      prop="ctCount",
      header-align="center",
      align="center",
      label="已结束比赛场次(数)"
    )
    el-table-column(
      prop="ctCountNoEnd",
      header-align="center",
      align="center",
      label="未结束比赛场次(数)"
    )
    el-table-column(
      prop="endTotalAmountCt",
      header-align="center",
      align="center",
      label="已结束比赛总额(元)"
    )
      template(slot-scope="scope")
        font(v-if="scope.row.endTotalAmountCt != null")
          span ¥ {{ parseFloat(scope.row.endTotalAmountCt).toFixed(2) }} 元
    el-table-column(
      prop="trCount",
      header-align="center",
      align="center",
      label="已结束培训场次(数)"
    )
    el-table-column(
      prop="trCountNoEnd",
      header-align="center",
      align="center",
      label="未结束培训场次(数)"
    )
    el-table-column(
      prop="endTotalAmountTr",
      header-align="center",
      align="center",
      label="已结束培训总额(元)"
    )
      template(slot-scope="scope")
        font(v-if="scope.row.endTotalAmountTr != null")
          span ¥ {{ parseFloat(scope.row.endTotalAmountTr).toFixed(2) }} 元
    el-table-column(
      prop="placeAmt",
      header-align="center",
      align="center",
      label="约场地总额(元)"
    )
      template(slot-scope="scope")
        font(v-if="scope.row.placeAmt != null")
          span ¥ {{ parseFloat(scope.row.placeAmt).toFixed(2) }} 元
    //- el-table-column(prop='searchDate', header-align='center', align='center', :label='dataForm.dateType===1?"月份":dataForm.dateType===2?"季度":"年份"')
    //-   template(slot-scope="scope")
    //-       font(v-if='dataForm.dateType===1')
    //-         span() {{scope.row.searchDate}}
    //-       font(v-if='dataForm.dateType===2')
    //-         span() {{scope.row.searchDate}}季度
    //-       font(v-if='dataForm.dateType===3')
    //-         span() {{scope.row.searchDate}}年
    el-table-column(
      prop="totalAmount",
      header-align="center",
      align="center",
      label="总收入(元)"
    )
      template(slot-scope="scope")
        font(
          v-if="scope.row.totalAmount != null && scope.row.refundBalance != null"
        )
          span ¥ {{ tableComputed_1(scope.row.totalAmount, scope.row.refundBalance) }} 元
    el-table-column(
      prop="totalAmount",
      header-align="center",
      align="center",
      label="不含退款收入(元)"
    )
      template(slot-scope="scope")
        font(v-if="scope.row.totalAmount != null")
          span ¥ {{ parseFloat(scope.row.totalAmount).toFixed(2) }} 元
    el-table-column(
      prop="totalFranchise",
      header-align="center",
      align="center",
      label="加盟费(元)"
    )
      template(slot-scope="scope")
        font(v-if="scope.row.totalFranchise != null")
          span ¥ {{ parseFloat(scope.row.totalFranchise).toFixed(2) }} 元
    el-table-column(
      prop="totalAmountFranchiseePay",
      header-align="center",
      align="center",
      label="加盟商打款总额(元)"
    )
      template(slot-scope="scope")
        font(v-if="scope.row.totalAmountFranchiseePay != null")
          span ¥ {{ parseFloat(scope.row.totalAmountFranchiseePay).toFixed(2) }} 元
    el-table-column(
      prop="refundBalance",
      header-align="center",
      align="center",
      label="退款余额(元)"
    )
      template(slot-scope="scope")
        font(v-if="scope.row.refundBalance != null")
          span ¥ {{ parseFloat(scope.row.refundBalance).toFixed(2) }} 元
    el-table-column(
      prop="refundBalance",
      header-align="center",
      align="center",
      label="退款余额度占比(%)"
    )
      template(slot-scope="scope")
        font(
          v-if="scope.row.totalAmount != null && scope.row.refundBalance != null"
        )
          span(
            :style="tableComputed_3(scope.row.totalAmount, scope.row.refundBalance)"
          ) {{ tableComputed_2(scope.row.totalAmount, scope.row.refundBalance) }} %
    el-table-column(
      prop="serviceFee",
      header-align="center",
      align="center",
      label="提现手续费(元)"
    )
      template(slot-scope="scope")
        font(v-if="scope.row.serviceFee != null")
          span ¥ {{ parseFloat(scope.row.serviceFee).toFixed(2) }} 元
    el-table-column(
      prop="accountName",
      header-align="center",
      align="center",
      label="开户名"
    )
      template(slot-scope="scope")
        font(v-if="scope.row.accountName != null")
          span {{ scope.row.accountName }}
    el-table-column(
      prop="accountBank",
      header-align="center",
      align="center",
      label="开户行"
    )
      template(slot-scope="scope")
        font(v-if="scope.row.accountBank != null")
          span {{ scope.row.accountBank }}
    el-table-column(
      prop="accountNo",
      header-align="center",
      align="center",
      label="账号"
    )
      template(slot-scope="scope")
        font(v-if="scope.row.accountNo != null")
          span {{ scope.row.accountNo }}
    el-table-column(
      prop="taxId",
      header-align="center",
      align="center",
      label="税号"
    )
      template(slot-scope="scope")
        font(v-if="scope.row.taxId != null")
          span {{ scope.row.taxId }}
    el-table-column(
      prop="accountAddress",
      header-align="center",
      align="center",
      label="地址"
    )
      template(slot-scope="scope")
        font(v-if="scope.row.accountAddress != null")
          span {{ scope.row.accountAddress }}
    el-table-column(prop='orgContactName', header-align='center', align='center', label='联系人')
      template(slot-scope='scope')
        span(:title="scope.row.orgContactName") {{scope.row.orgContactName || ''}}
    el-table-column(prop='orgContactPhone', header-align='center', align='center', label='联系电话')
      template(slot-scope='scope')
        span(:title="scope.row.orgContactPhone") {{scope.row.orgContactPhone || ''}}
    el-table-column(
      prop="",
      header-align="center",
      align="center",
      label="操作",
      width="100"
    )
      template(slot-scope="scope")
        el-menu.menuPonit(
          @open="handleOpen",
          @close="handleClose",
          :collapse="isCollapse"
        )
          el-submenu(index="1")
            template(slot="title")
              i.el-icon-more(style="color: #02b90d")
            el-menu-item-group
              el-menu-item(index="1-1", @click="toDetail(scope.row)") 详情

  el-pagination(
    @size-change="sizeChangeHandle",
    @current-change="currentChangeHandle",
    :current-page="pageIndex",
    :page-sizes="[10, 20, 50, 100]",
    :page-size="pageSize",
    :total="totalPage",
    layout="total, sizes, prev, pager, next, jumper"
  )
</template>
<script>
import table from "./table.js";
// import table2 from './table2.js'
export default {
  name: "statical-franchiseStatical",
  data() {
    return {
      table: {
        columns: table.columns,
        data: null,
        size: "mini",
        stripe: true,
        border: true,
      },
      isCollapse: true,
      timeRange: 1,
      dateTime: "",
      totalAmount: null,
      totalAmountCt: null,
      totalAmountTr: null,
      totalFranchise: null,
      totalFranchiseCt: null,
      totalFranchiseTr: null,
      serviceFee: null,
      ctCount: null,
      trCount: null,
      dataForm: {
        payTimeStr: "",
        payTimeEnd: "",
        busType: null, //竞赛/培训类型
        busCategory: "",
        orgId: "",
        numType: 1,
        dateType: 1,
        downLoad: false,
      },
      orgList: [],
      dataList: [],
      infoDataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      viewVisible: false,
    };
  },
  created() {
    this.timeChange(1); //默认本周
    this.getDataList();
    this.changeOrg();
  },
  computed: {
    // 总收入 = 不含退款收入(a) + 退款余额(b)
    tableComputed_1() {
      return function (a, b) {
        return (Number(a) + Number(b)).toFixed(2);
      };
    },
    // 退款余额度占比 = 退款余额(b) / 总收入(a + b)
    tableComputed_2() {
      return function (a, b) {
        if (Number(b) === 0) {
          return "0.00";
        }
        const num1 = Number(b) / (Number(a) + Number(b));
        const num2 = num1 * 100;
        const num3 = num2.toFixed(2);
        return num3;
      };
    },
    // 退款余额度占比超过 10% 时需要进行标红处理
    tableComputed_3() {
      return function (a, b) {
        if (Number(b) === 0) {
          return "";
        }
        const num1 = Number(b) / (Number(a) + Number(b));
        const num2 = num1 * 100;
        const num3 = num2.toFixed(2);
        if (Number(num3) < 10) {
          return "";
        } else {
          return "color: red;";
        }
      };
    },
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      if (this.dateTime && this.dateTime.length > 0) {
        this.dataForm.payTimeStr = this.dateTime[0];
        this.dataForm.payTimeEnd = this.dateTime[1];
      }
      this.dataForm.page = this.pageIndex;
      this.dataForm.rows = this.pageSize;
      this.$http({
        url: this.$http.adornUrl("/frFranchiseFeeRecord/franchiseFeeList"),
        method: "post",
        data: this.dataForm,
      }).then((data) => {
        if (data && data.code === 0) {
          this.dataList = data.page.rows;
          this.totalPage = data.page.total;
          this.totalAmount = data.totalAmount;
          this.totalAmountCt = data.totalAmountCt;
          this.totalAmountTr = data.totalAmountTr;
          this.totalFranchise = data.totalFranchise;
          this.totalFranchiseCt = data.totalFranchiseCt;
          this.totalFranchiseTr = data.totalFranchiseTr;
          this.serviceFee = data.serviceFee;
          this.ctCount = data.ctCount;
          this.trCount = data.trCount;
          if (this.dataList.length > 0) {
            this.infoDataList = [
              {
                totalAmount: data.totalAmount,
                totalAmountCt: data.totalAmountCt,
                totalAmountTr: data.totalAmountTr,
                totalFranchise: data.totalFranchise,
                totalFranchiseCt: data.totalFranchiseCt,
                totalFranchiseTr: data.totalFranchiseTr,
                serviceFee: data.serviceFee,
                ctCount: data.ctCount,
                totalCtNotEndCount: data.totalCtNotEndCount,
                endTotalAmountCt: data.endTotalAmountCt,
                trCount: data.trCount,
                totalTrNotEndCount: data.totalTrNotEndCount,
                endTotalAmountTr: data.endTotalAmountTr,
                totalPlaceAmt: data.totalPlaceAmt,
                totalRefundBalanced: data.totalRefundBalanced,
                totalAmountFranchiseePay: data.totalAmountFranchiseePay,
              },
            ];
          } else {
            this.infoDataList = [];
          }
        } else {
          this.dataList = [];
          this.infoDataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    changeBusType(val) {
      if (val === 1) {
        this.busCategoryArr = [
          { value: 1, label: "分级公开赛" },
          { value: 2, label: "俱乐部公开赛" },
        ];
      } else {
        this.busCategoryArr = [
          { value: 3, label: "分级单次培训" },
          { value: 4, label: "分级整期培训" },
          { value: 5, label: "青少年儿童培训" },
          { value: 6, label: "个人定制化培训" },
        ];
      }
    },
    // 快捷选择时间范围
    timeChange(val) {
      const today = new Date();
      let start = null;
      let end = null;
      // 0 今天
      // 1 本周(周一到今天)
      // 2 上周(上周一到上周日)
      // 3 本月(本月1号到今天)
      // 4 上月(上月1号到上月最后一天)
      if (val === 0) {
        start = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate()
        );
        end = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      } else if (val === 1) {
        // 周日为 0, 转为 7
        const day = today.getDay() || 7;
        // 本周一
        start = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - day + 1
        );
        // 今天
        end = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      } else if (val === 2) {
        const day = today.getDay() || 7;
        // 上周日
        end = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - day
        );
        // 上周一
        start = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - day - 6
        );
      } else if (val === 3) {
        // 本月第一天
        start = new Date(today.getFullYear(), today.getMonth(), 1);
        // 今天
        end = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      } else if (val === 4) {
        // 上月
        const lastMonth = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          1
        );
        // 上月第一天
        start = new Date(lastMonth.getFullYear(), lastMonth.getMonth(), 1);
        // 上月最后一天
        end = new Date(lastMonth.getFullYear(), lastMonth.getMonth() + 1, 0);
      }

      this.dateTime = [this.getime(start), this.getime(end)];
    },
    getime(time) {
      let str = "";
      let y = time.getFullYear();
      let m = (time.getMonth() + 1 + "").padStart(2, "0");
      let d = (time.getDate() + "").padStart(2, "0");
      str = `${y}-${m}-${d}`;
      return str;
    },
    getDownLoadTime(time) {
      let str = "";
      let y = time.getFullYear();
      let m = (time.getMonth() + 1 + "").padStart(2, "0");
      let d = (time.getDate() + "").padStart(2, "0");
      str = `${y}${m}${d}`;
      return str;
    },
    dayChange() {
      this.timeRange = "";
    },
    dateChange(val) {
      this.dataForm.dateType = val;
      this.getDataList();
    },
    handleClose() {},
    handleOpen() {},
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    toDetail(row) {
      this.$router.push({
        path: "./franchiseOrgStatical",
        query: {
          refresh: 1,
          orgId: row.orgId,
          timeRange: this.timeRange,
          payTimeStr: this.dateTime[0] || "",
          payTimeEnd: this.dateTime[1] || "",
        },
      });
    },
    changeOrg() {
      this.$http({
        url: this.$http.adornUrl("/sysOrg/list"),
        method: "get",
        params: this.$http.adornParams(),
      }).then((data) => {
        this.orgList = data && data.code === 0 ? data.list : [];
      });
    },
    exportExcel() {
      //导出列表
      if (this.dateTime && this.dateTime.length > 0) {
        this.dataForm.payTimeStr = this.dateTime[0];
        this.dataForm.payTimeEnd = this.dateTime[1];
      }
      this.dataForm.page = 1;
      this.dataForm.rows = 100000;
      this.dataForm.downLoad = true;
      this.$http({
        url: this.$http.adornUrl("/frFranchiseFeeRecord/franchiseFeeList"),
        method: "POST",
        data: this.dataForm,
      }).then((data) => {
        if (data && data.code === 0) {
          if (data.page.rows == null || data.page.rows.length === 0) {
            this.$message.info("没有要导出的数据!");
            return;
          }
          // const totalData = [{
          //   ctCount: data.ctCount,
          //   totalCtNotEndCount: data.totalCtNotEndCount,
          //   endTotalAmountCt: data.endTotalAmountCt,
          //   trCount: data.trCount,
          //   totalTrNotEndCount: data.totalTrNotEndCount,
          //   endTotalAmountTr: data.endTotalAmountTr,
          //   totalPlaceAmt: data.totalPlaceAmt,
          //   totalAmount: data.totalAmount,
          //   totalRefundBalanced: data.totalRefundBalanced,
          //   totalAmountFranchiseePay: data.totalAmountFranchiseePay,
          //   totalFranchise: data.totalFranchise,
          //   serviceFee: data.serviceFee
          // }]
          let exportData = data.page.rows;
          for (let i of exportData) {
            i.searchDate =
              i.searchDate +
              { 1: "", 2: "季度", 3: "年" }[this.dataForm.dateType];
            // 如果这个数据是可以转化为数字的格式，但我们又不希望它被转化的时候，
            // 就需要在数据前面添加一个“keepString”前缀，这个前缀会在数据被转化为Excel表格的时候被自动删除
            if (i.accountNo) {
              i.accountNo = 'keepString' + i.accountNo
            }
            if (i.orgContactPhone) {
              i.orgContactPhone = 'keepString' + i.orgContactPhone
            }
          }
          this.$export
            .excel({
              columns: this.table.columns,
              data: exportData,
              title: "加盟费按加盟商统计",
              header: this.dateTime && this.dateTime.length > 0 ? `${this.dateTime[0]} ~ ${this.dateTime[1]}` : ''
            })
            .then(() => {
              this.$message.success("加盟费按加盟商统计导出成功");
            });
          // this.$export.excel({
          //   columns: table2.columns,
          //   data: totalData,
          //   title: '加盟费统计总表'
          // }).then(() => {
          //   this.$message.success('加盟费统计总表导出成功')
          //   setTimeout(() => {
          //     this.$export.excel({
          //       columns: this.table.columns,
          //       data: exportData,
          //       title: '加盟费按加盟商统计'
          //     }).then(() => {
          //       this.$message.success('加盟费按加盟商统计导出成功')
          //     })
          //   }, 1000)
          // })
        }
      });
    },
  },
};
</script>
<style>
/* 操作三点 菜单样式 */
@import "../../css/opr3dot.css";
</style>>
